'use client'

import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'

const blockSkeleton = cva('skeleton-pulse w-full rounded-2', {
    variants: {
        height: {
            1: 'h-12.5',
            2: 'h-25',
            3: 'h-37.5',
            4: 'h-50',
            5: 'h-62.5',
            6: 'h-75',
            7: 'h-87.5',
            8: 'h-100',
            9: 'h-112.5',
            10: 'h-125'
        }
    },
    defaultVariants: {
        height: 5
    }
})

type BlockSkeletonProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof blockSkeleton>

const BlockSkeleton = ({ height, className, ...props }: BlockSkeletonProps) => (
    <div className={blockSkeleton({ height, className })} {...props} />
)

export default BlockSkeleton
